/**
 * Suite-only coach prices server function — auth plus delegation to
 * `~/lib/server/suite-plan-offer`.
 *
 * Aliases: your plan page prices, suite plan offer function
 */

import { createServerFn } from "@tanstack/react-start";

import { requireClerkCoachAuth } from "~/lib/coach-middleware";
import type { SuitePlanOfferFacts } from "~/lib/shared/suite-plan-offer";

export const getSuitePlanOffer = createServerFn({ method: "GET" })
  .middleware([requireClerkCoachAuth])
  .handler(async ({ context }): Promise<SuitePlanOfferFacts> => {
    const { readSuitePlanOffer } =
      await import("~/lib/server/suite-plan-offer");
    return readSuitePlanOffer(context.coach);
  });
